/* eslint-disable */
import * as React from "react";

import { Typography } from "@material-ui/core";
import { useIntl } from "react-intl";
import { createStyles } from "@material-ui/styles";
import { Theme, makeStyles } from "@material-ui/core";
import { messages } from "./SubscriptionsSettings.messages";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      color: theme.palette.common.black,
      opacity: 0.5,
      marginTop: theme.spacing(-2),
      fontSize: "14px",
      fontWeight: "bold",
      lineHeight: "17px",
    },
  })
);
const formatter = Intl.DateTimeFormat("en-US", {
  month: "long",
  day: "numeric",
  year: "numeric",
});

type SubscriptionsSettingsDateProps = {
  value: string;
};

export const SubscriptionsSettingsDate: React.FC<SubscriptionsSettingsDateProps> = (props: SubscriptionsSettingsDateProps) => {
  const { value } = props;
  const { formatMessage } = useIntl();
  const classes = useStyles();

  return <Typography className={classes.root}>{`${formatMessage(messages.saveDate)}: ${formatter.format(new Date(value))}`}</Typography>;
};
